// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XuI7RoZAns451YEeKV9v {
  box-sizing: border-box;
  width: min(25rem, calc(100vw - 1rem));
  padding: 0 1.5rem 1.5rem;
}

.ZzehEAH0AUEvnaHcBzWA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.WZUWk3Ep9tA8NgTzZBAn {
  color: var(--sl-fg-base, #2a2f35);
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.Esu1fmST6AlpWRip81dh {
  border: none;
  padding: 0;
  background: none;
  color: var(--primary, #1a73e8);
  font-size: 0.875rem;
  font-weight: 600;
}

.Esu1fmST6AlpWRip81dh:disabled {
  cursor: not-allowed;
  color: var(--sl-fg-base-disabled, #9aa3ad);
}

.KuCJrzDZJxkJUazuHveY {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.bD7PYCsc5hWVDeJJI93r {
  margin: 0;
  padding: 0;
}

.ZtzTo2eWZ3TvYN2JcWtS {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.NUrYgI5V92iQFBF0rqn9 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-height: 2.5rem;
  border: none;
  border-radius: 0.75rem;
  padding: 0.625rem 0.75rem;
  background: transparent;
  color: var(--sl-fg-base, #2a2f35);
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.NUrYgI5V92iQFBF0rqn9[data-selected='true'],
.NUrYgI5V92iQFBF0rqn9[data-readonly='true'] {
  background: #edf3fb;
}

.NUrYgI5V92iQFBF0rqn9[data-readonly='true'] {
  cursor: default;
}

.NUrYgI5V92iQFBF0rqn9[data-selected='false'][data-readonly='false']:hover {
  background: #f7faff;
}

.NUrYgI5V92iQFBF0rqn9:has(:focus-visible) {
  outline: 2px solid var(--primary, #1a73e8);
  outline-offset: 2px;
}

.ehXznbDPeKqV1a2kWaFm {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.hSHByrwczZgyD7BstedA {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  color: var(--primary, #1a73e8);
}

.xp2Q0Su7omiMxiKELAtI {
  color: var(--sl-fg-muted, #8e98a3);
}

.dY4THVEXJHyxXDINwHL2 {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/ColumnSelector/Drawer/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf;;mBAEiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".drawer {\n  box-sizing: border-box;\n  width: min(25rem, calc(100vw - 1rem));\n  padding: 0 1.5rem 1.5rem;\n}\n\n.summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.visibleCount {\n  color: var(--sl-fg-base, #2a2f35);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.uncheckAll {\n  border: none;\n  padding: 0;\n  background: none;\n  color: var(--primary, #1a73e8);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.uncheckAll:disabled {\n  cursor: not-allowed;\n  color: var(--sl-fg-base-disabled, #9aa3ad);\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.listItem {\n  margin: 0;\n  padding: 0;\n}\n\n.checkbox {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  min-height: 2.5rem;\n  border: none;\n  border-radius: 0.75rem;\n  padding: 0.625rem 0.75rem;\n  background: transparent;\n  color: var(--sl-fg-base, #2a2f35);\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease;\n}\n\n.row[data-selected='true'],\n.row[data-readonly='true'] {\n  background: #edf3fb;\n}\n\n.row[data-readonly='true'] {\n  cursor: default;\n}\n\n.row[data-selected='false'][data-readonly='false']:hover {\n  background: #f7faff;\n}\n\n.row:has(:focus-visible) {\n  outline: 2px solid var(--primary, #1a73e8);\n  outline-offset: 2px;\n}\n\n.rowLabel {\n  flex: 1;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.rowIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  color: var(--primary, #1a73e8);\n}\n\n.rowIconReadonly {\n  color: var(--sl-fg-muted, #8e98a3);\n}\n\n.rowIconHidden {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `XuI7RoZAns451YEeKV9v`,
	"summary": `ZzehEAH0AUEvnaHcBzWA`,
	"visibleCount": `WZUWk3Ep9tA8NgTzZBAn`,
	"uncheckAll": `Esu1fmST6AlpWRip81dh`,
	"list": `KuCJrzDZJxkJUazuHveY`,
	"listItem": `bD7PYCsc5hWVDeJJI93r`,
	"checkbox": `ZtzTo2eWZ3TvYN2JcWtS`,
	"row": `NUrYgI5V92iQFBF0rqn9`,
	"rowLabel": `ehXznbDPeKqV1a2kWaFm`,
	"rowIcon": `hSHByrwczZgyD7BstedA`,
	"rowIconReadonly": `xp2Q0Su7omiMxiKELAtI`,
	"rowIconHidden": `dY4THVEXJHyxXDINwHL2`
};
export default ___CSS_LOADER_EXPORT___;
